import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";

const rup = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export default function CashbookPrint() {
  const [params] = useSearchParams();
  const days = params.get("days") || "30";
  const [data, setData] = useState(null);
  const [thermal, setThermal] = useState(false);
  useEffect(() => {
    Promise.all([api.get(`/admin/cashbook?days=${days}`), api.get("/admin/business-settings")])
      .then(([cb, bs]) => { setData({ ...cb.data, biz: bs.data }); setTimeout(() => window.print(), 700); })
      .catch(() => setData(false));
  }, [days]);
  if (data === false) return <div style={{ padding: 40, fontFamily: "Arial" }}>Could not load cashbook.</div>;
  if (!data) return <div style={{ padding: 40, fontFamily: "Arial" }}>Loading…</div>;
  const { totals, days: daylist, biz } = data;
  const width = thermal ? 300 : 760;

  return (
    <div style={{ fontFamily: "Arial, sans-serif", color: "#111", background: "#f1f5f9", minHeight: "100vh", padding: 16 }} data-testid="cashbook-print">
      <style>{`@media print{.no-print{display:none!important}body{background:#fff}.sheet{box-shadow:none!important}} .sheet{background:#fff;width:${width}px;margin:0 auto;padding:26px 30px;box-shadow:0 1px 6px rgba(0,0,0,.12)}`}</style>
      <div className="no-print" style={{ width, margin: "0 auto 12px", display: "flex", justifyContent: "space-between" }}>
        <button onClick={() => setThermal(!thermal)} data-testid="cbp-size-toggle" style={{ padding: "8px 14px", background: "#1e293b", color: "#fff", border: "none", borderRadius: 8, fontWeight: 700, cursor: "pointer" }}>{thermal ? "A4 Size" : "58mm Thermal"}</button>
        <button onClick={() => window.print()} style={{ padding: "8px 16px", background: "#0B8E36", color: "#fff", border: "none", borderRadius: 8, fontWeight: 700, cursor: "pointer" }}>Print / Save PDF</button>
      </div>
      <div className="sheet">
        <div style={{ textAlign: "center", marginBottom: 14 }}>
          <div style={{ fontWeight: 800, fontSize: 20 }}>{biz.name}</div>
          {biz.address && <div style={{ fontSize: 12, color: "#475569" }}>{biz.address}{biz.city ? `, ${biz.city}` : ""}</div>}
          {biz.phone && <div style={{ fontSize: 12, color: "#475569" }}>Ph: {biz.phone}</div>}
          <div style={{ fontWeight: 800, fontSize: 15, marginTop: 8, borderTop: "2px dashed #94a3b8", borderBottom: "2px dashed #94a3b8", padding: "6px 0" }}>CASHBOOK · Last {days} Days</div>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", background: "#f1f5f9", borderRadius: 8, padding: "10px 12px", fontSize: 13, marginBottom: 12 }}>
          <span style={{ color: "#059669", fontWeight: 700 }}>In: {rup(totals.in)}</span>
          <span style={{ color: "#d97706", fontWeight: 700 }}>Out: {rup(totals.out)}</span>
          <span style={{ fontWeight: 800, color: totals.net >= 0 ? "#059669" : "#dc2626" }}>Net: {rup(totals.net)}</span>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, color: "#334155", fontWeight: 700, marginBottom: 12 }}>
          <span>Opening Balance: {rup(data.opening_balance)}</span>
          <span>Closing (Cash in Hand): {rup(data.closing_balance)}</span>
        </div>
        {daylist.map((d) => (
          <div key={d.date} style={{ marginBottom: 14, pageBreakInside: "avoid" }}>
            <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 800, fontSize: 13, borderBottom: "1px solid #cbd5e1", paddingBottom: 3, marginBottom: 4 }}>
              <span>{d.date} <span style={{ fontWeight: 400, color: "#94a3b8", fontSize: 11 }}>· open {rup(d.opening)} → close {rup(d.closing)}</span></span>
              <span style={{ color: d.net >= 0 ? "#059669" : "#dc2626" }}>{rup(d.net)}</span>
            </div>
            <table style={{ width: "100%", fontSize: 12, borderCollapse: "collapse" }}>
              <tbody>
                {d.entries.map((e, i) => (
                  <tr key={`${e.kind}-${e.label}-${i}`}>
                    <td style={{ padding: "3px 0", color: "#64748b", width: 34 }}>{e.kind === "in" ? "IN" : "OUT"}</td>
                    <td style={{ padding: "3px 0" }}>{e.label} <span style={{ color: "#94a3b8" }}>· {e.method?.toUpperCase()}</span></td>
                    <td style={{ padding: "3px 0", textAlign: "right", fontWeight: 700, color: e.kind === "in" ? "#059669" : "#d97706" }}>{e.kind === "in" ? "+" : "-"}{rup(e.amount)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
        {daylist.length === 0 && <p style={{ textAlign: "center", color: "#94a3b8", fontSize: 12 }}>Koi entry nahi</p>}
        <p style={{ textAlign: "center", fontSize: 12, marginTop: 16, color: "#475569" }}>{biz.footer_note}</p>
      </div>
    </div>
  );
}
